/**
 * Domain entities — factories and pure helpers.
 *
 * Runtime-safe wrappers around the typedefs declared in /contracts.
 * Factories exist so engines and adapters produce entities the same way.
 * They add NO business rules — just id/uuid/timestamp defaults.
 */

function uuid() {
  // RFC4122-ish; sufficient for demo determinism when seeded elsewhere
  return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

const nowIso = () => new Date().toISOString();

/** @returns {import('../contracts').Actor} */
export const createActor = (data) => ({
  id: uuid(),
  organizationId: "demo-org",
  vertical: "software_distributors",
  stage: "inactive",
  source: "manual",
  isDemo: true,
  firstSeenAt: nowIso(),
  ...data,
});

/** @returns {import('../contracts').Signal} */
export const createSignal = (data) => ({
  id: uuid(),
  occurredAt: nowIso(),
  weight: "medium",
  ...data,
});

/** @returns {import('../contracts').Opportunity} */
export const createOpportunity = (data) => ({
  id: uuid(),
  outcome: "pending",
  responseStatus: "not_contacted",
  updatedAt: nowIso(),
  isDemo: true,
  ...data,
});

/** @returns {import('../contracts').Play} */
export const createPlay = (data) => ({
  id: uuid(),
  generatedBy: "template",
  generatedAt: nowIso(),
  expectedLiftPct: 0.1,
  ...data,
});

/** @returns {import('../contracts').Outcome} */
export const createOutcome = (data) => ({
  id: uuid(),
  recordedAt: nowIso(),
  recordedBy: "user-me",
  ...data,
});

/** @returns {import('../contracts').Closure} */
export const createClosure = (data) => ({
  id: uuid(),
  closedAt: nowIso(),
  closedBy: "user-me",
  ...data,
});
